import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import MetaTags from "react-meta-tags";
import { withRouter, Link } from "react-router-dom";

import BootstrapTable from "react-bootstrap-table-next";
import filterFactory from "react-bootstrap-table2-filter";

import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  Button,
  ModalBody,
  Input,
} from "reactstrap";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";

import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import Breadcrumbs from "components/Common/Breadcrumb";

import {
  getCommentscyclerenew,
  addCommentscyclerenew,
} from "store/news/actions";

import "assets/scss/table.scss";
import moment from "moment";

class CommentsCycleRenew2 extends Component {
  constructor(props) {
    super(props);
    this.node = React.createRef();
    this.state = {
      modal: false,
      modalTitle: "",
      modalText: "",
      modalImage: "",
      modalDate: "",
      authUserId: localStorage.getItem("authUser")
        ? parseInt(JSON.parse(localStorage.getItem("authUser")).user_id)
        : null,
      // ✅ New fields
      scheme_id: null,
      scheme_name: "",
      round_id: null,
      round_name: "",
      participantId: this.props.match.params.id, // keep participant id separately
      newCommentText: "",
      isAddingComment: false,
    };
  }
componentDidMount() {
  const { location } = this.props;

  // Extract query params
  const searchParams = new URLSearchParams(location.search);
  const participantId = searchParams.get("participant_id");
  const scheme = searchParams.get("scheme");
  const scheme_name = searchParams.get("scheme_name") || "";

  if (participantId) {
    this.setState(
      {
        participantId: parseInt(participantId),
        scheme_id: scheme ? parseInt(scheme) : null,
        scheme_name,
      },
      () => {
        console.log("📥 Fetching comments for participant:", this.state.participantId);
        this.props.onGetCommentscyclerenew(this.state.participantId);
      }
    );
  } else {
    console.warn("⚠️ No participant_id found in URL query string");
  }
}

  toggleModal = () => {
    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

 handleAddComment = () => {
  const {
    newCommentText,
    authUserId,
    // authUserName, // make sure you have the user's name in state
    participantId,
    scheme_id,
  } = this.state;
  const { onAddCommentscyclerenew } = this.props;

  if (!newCommentText.trim()) return;

  // Extract query params from URL
  const searchParams = new URLSearchParams(window.location.search);
  const province = searchParams.get("province");
  const district = searchParams.get("district");
  const city = searchParams.get("city");
  const scheme = searchParams.get("scheme");
  const scheme_name = searchParams.get("scheme_name"); // optional

 const commentData = {
  added_by: authUserId,
  participant_id: parseInt(participantId), // <--- use participant_id here
  text: newCommentText.trim(),
  scheme_id: scheme_id || scheme || null,
  scheme_name: scheme_name || null,
  province: province || null,
  district: district || null,
  city: city || null,
  timestamp: new Date().toISOString(),
};


  this.setState({ newCommentText: "" });

  return new Promise((resolve, reject) => {
    onAddCommentscyclerenew(commentData, resolve, reject);
  })
    .then(() => {
      this.props.onGetCommentscyclerenew(participantId);
    })
    .catch(error => {
      console.error("Failed to add comment:", error);
    });
};


  render() {
    const { SearchBar } = Search;
    const { cyclerenew } = this.props;

    const pageOptions = {
      sizePerPage: 10,
      totalSize: cyclerenew.length,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id",
        order: "desc",
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <MetaTags>
            <title>Comments</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="Updates" breadcrumbItem="Comments" />

            {/* Add Comment Input + Button */}
            <Row className="justify-content-center">
              <Col lg="8">
                <Card className="shadow-sm">
                  <CardBody
                    style={{
                      height: "500px",
                      overflowY: "auto",
                      background: "#f5f7fb",
                    }}
                  >
                    {cyclerenew && cyclerenew.length > 0 ? (
                      [...cyclerenew] // make a shallow copy
                        .sort(
                          (a, b) =>
                            new Date(a.date_added) - new Date(b.date_added)
                        ) // ✅ oldest first
                        .map(comment => (
                          <div
                            key={comment.id}
                            className={`d-flex mb-3 ${
                              comment.added_by === this.state.authUserId
                                ? "justify-content-end"
                                : "justify-content-start"
                            }`}
                          >
                            <div
                              className={`p-3 rounded-3 shadow-sm ${
                                comment.added_by === this.state.authUserId
                                  ? "bg-info-subtle text-dark"
                                  : "bg-primary-subtle text-dark"
                              }`}
                              style={{ maxWidth: "70%" }}
                            >
                              <div className="fw-bold mb-1">
                                {comment.added_by === this.state.authUserId
                                  ? "You"
                                  : comment.added_by_name || "Participant"}
                              </div>
                              <div>{comment.text}</div>

                              {/* ✅ Show scheme/round info if available */}
                              {(comment.scheme_name || comment.round_name) && (
                                <div
                                  className="text-muted mt-1"
                                  style={{ fontSize: "0.8rem" }}
                                >
                                  {comment.scheme_name && (
                                    <span>
                                      <strong>Scheme: </strong>
                                      {comment.scheme_name}
                                    </span>
                                  )}
                                  {comment.scheme_name &&
                                    comment.round_name && <span> | </span>}
                                  {comment.round_name && (
                                    <span>
                                      <strong>Round:</strong>{" "}
                                      {comment.round_name}
                                    </span>
                                  )}
                                </div>
                              )}

                              <small
                                className="text-muted d-block mt-1"
                                style={{ fontSize: "0.8rem" }}
                              >
                                {moment(comment.date_added).format(
                                  "DD-MMM-YY, h:mm A"
                                )}
                              </small>
                            </div>
                          </div>
                        ))
                    ) : (
                      <p className="text-center text-muted">No comments yet.</p>
                    )}
                  </CardBody>

                  {/* Input Box like Chat */}
                  <div className="d-flex border-top p-3">
                    <Input
                      type="text"
                      placeholder="Type your comment..."
                      value={this.state.newCommentText}
                      onChange={e =>
                        this.setState({ newCommentText: e.target.value })
                      }
                      onKeyDown={e => {
                        if (
                          e.key === "Enter" &&
                          this.state.newCommentText.trim()
                        ) {
                          this.handleAddComment();
                        }
                      }}
                    />
                    <Button
                      color="primary"
                      className="ms-2"
                      disabled={!this.state.newCommentText.trim()}
                      onClick={this.handleAddComment}
                    >
                      Send
                    </Button>
                  </div>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
CommentsCycleRenew2.propTypes = {
  cyclerenew: PropTypes.array,
  onAddCommentscyclerenew: PropTypes.func.isRequired,
  onGetCommentscyclerenew: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      schemeId: PropTypes.string,
      roundId: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    search: PropTypes.string.isRequired, // ✅ mark as required
    state: PropTypes.object,
  }).isRequired, // ✅ mark location itself as required
};


const mapStateToProps = ({ news }) => ({
  cyclerenew: news.cyclerenew,
});

const mapDispatchToProps = (dispatch) => ({
  onAddCommentscyclerenew: (data, resolve, reject) =>
    dispatch(addCommentscyclerenew(data, resolve, reject)),
  onGetCommentscyclerenew: (id) => dispatch(getCommentscyclerenew(id)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(CommentsCycleRenew2));
